import { dependentKeyCompat } from '@ember/object/compat';
import { service } from '@ember/service';

import Model, { attr } from '@warp-drive/legacy/model';

import { CMS_LANGUAGE_IDS } from 'umg-ember-backend/utils/cms-languages';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  cmsLanguageId: [
    validator('inclusion', { in: CMS_LANGUAGE_IDS }),
    validator('presence', true),
    validator('unique-language-variant', {
      messageKey: 'forms.defaults.messages.cmsLanguageId',
      dependentKeys: ['model.variants.@each', 'model.variantChannel'],
    }),
  ],
});

export default class VariantModelModel extends Model.extend(Validations) {
  // Services
  @service recordVariants;

  // Attributes
  @attr('string', { defaultValue: '0' }) cmsVariantParentId;
  @attr('string', { defaultValue: '1' }) cmsLanguageId;

  // TODO: Create variants relation
  @dependentKeyCompat
  get variants() {
    return this.recordVariants.getVariants(this);
  }
}
